<template>
	<JBox></JBox>
</template>

<script>
export default {}
</script>
